import { render, staticRenderFns } from "./detailsBanner.vue?vue&type=template&id=412a8a2a&scoped=true"
import script from "./detailsBanner.vue?vue&type=script&lang=js"
export * from "./detailsBanner.vue?vue&type=script&lang=js"
import style0 from "./detailsBanner.vue?vue&type=style&index=0&id=412a8a2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412a8a2a",
  null
  
)

export default component.exports